import type { IAssignment, IAssignmentWrite, IAttachment, IComment, ICommentWrite, IHistoryEntry, ILink, ILinkWrite } from '@platform/core/types';
import type { HttpClient } from './HttpClient';
import type { IDownload } from './IDownload';

export class CollaborationDao {
  constructor(private readonly http: HttpClient) {}

  comments(recordId: string): Promise<IComment[]> { return this.http.get(`/records/${recordId}/comments`); }
  addComment(recordId: string, body: ICommentWrite): Promise<IComment> { return this.http.post(`/records/${recordId}/comments`, body); }

  files(recordId: string): Promise<IAttachment[]> { return this.http.get(`/records/${recordId}/files`); }
  upload(recordId: string, file: File): Promise<IAttachment> { return this.http.upload(`/records/${recordId}/files`, file); }
  /** Вміст файлу запису з тими самими заголовками авторизації, що й решта запитів; ім'я — з Content-Disposition або `fileName`. */
  download(attachmentId: string, fileName: string): Promise<IDownload> { return this.http.download(`/files/${attachmentId}`, undefined, fileName); }

  assignments(recordId: string): Promise<IAssignment[]> { return this.http.get(`/records/${recordId}/assignments`); }
  addAssignment(recordId: string, body: IAssignmentWrite): Promise<IAssignment> { return this.http.post(`/records/${recordId}/assignments`, body); }

  history(recordId: string, page = 1, pageSize = 50): Promise<IHistoryEntry[]> {
    return this.http.get(`/records/${recordId}/history`, { page, pageSize });
  }

  watch(recordId: string, on: boolean): Promise<{ watching: boolean }> {
    return this.http.post(`/records/${recordId}/${on ? 'watch' : 'unwatch'}`);
  }

  links(recordId: string): Promise<ILink[]> { return this.http.get(`/records/${recordId}/links`); }
  addLink(recordId: string, body: ILinkWrite): Promise<ILink> { return this.http.post(`/records/${recordId}/links`, body); }
  removeLink(recordId: string, linkId: string): Promise<void> { return this.http.delete(`/records/${recordId}/links/${linkId}`); }
}
